<template>
  <TemplateHeader
    :header="'Emas Tersedia'"
    :withBackButton="true"
    :to="`/dashboard/${id}`"
    :branch_name="branch_name"
  >
    <TableEmas
      :tableLoading="tableLoading"
      :dataEmas="dataEmas"
      :headersEmas="headersEmas"
      :sortBy="dataEmas.id"
      :tableEdit="true"
    />
  </TemplateHeader>
</template>

<script>
import TemplateHeader from "../../../layouts/TemplateHeader.vue";
import TableEmas from "../../../components/Table/TableEmas.vue";
import { headersEmas } from "../../../data/headersEmas";
import dataService from "../../../services/data.service";

export default {
  components: {
    TemplateHeader,
    TableEmas,
  },
  data() {
    return {
      tableLoading: false,

      dataEmas: [],

      headersEmas: headersEmas,

      dataCabang: [],
      branch_name: "",
      id: this.$route.params.id,
    };
  },
  methods: {
    async getCabang() {
      this.cabangLoading = true;
      const id = this.$route.params.id;

      await dataService.getCabang().then((res) => {
        this.dataCabang = res.data;

        const findCabang = this.dataCabang.find((data) => data.id == id);

        this.branch_name = findCabang.branch_name;
        this.cabangLoading = false;
      });
    },
    async getProductsGold() {
      this.tableLoading = true;
      const id = this.$route.params.id;

      await dataService.getProductsBranchGold(id).then((res) => {
        this.dataEmas = res.data.data.filter(
          (data) =>
            data.status === "Tersedia" ||
            data.status === "Belum Terpindai" ||
            data.status === "Pindah Cabang" ||
            data.status === "Perbaikan"
        );

        this.tableLoading = false;
      });
    },
  },
  created() {
    this.getProductsGold();
    this.getCabang();
  },
};
</script>

<style scoped>
.myHeight {
  min-height: 100vh;
}
</style>
